//resend otp
export const PREDEFINED_TAGS_REQUEST = "PREDEFINED_TAGS_REQUEST";
export const PREDEFINED_TAGS_RECEIVE = "PREDEFINED_TAGS_RECEIVE";
export const PREDEFINED_TAGS_FAILURE = "PREDEFINED_TAGS_FAILURE";
export const RESET_PREDEFINED_TAGS= "RESET_PREDEFINED_TAGS";